import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Employee } from 'src/app/models/Employee';

import { ArchiveEmployee } from '../employees.actions';

@Component({
    selector: 'app-employees-archive-modal',
    templateUrl: './employees-archive-modal.component.html',
    styleUrls: ['./employees-archive-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class EmployeesArchiveModalComponent implements OnDestroy {
    private subscriptions = new Subscription();

    @Input() employee: Employee;
    public closeEvent: EventEmitter<void> = new EventEmitter();

    constructor(public activeModal: NgbActiveModal, private store: Store, private toastr: ToastrService, private logger: NGXLogger) {}

    archiveEmployee() {
        this.logger.debug('Attempt to archive employee');
        this.subscriptions.add(
            this.store.dispatch(new ArchiveEmployee(this.employee.uuid)).subscribe(
                () => {
                    this.logger.debug('Succesfully archived employee');
                    this.toastr.success('Employee archived successfully');
                    this.closeEvent.emit();
                    this.activeModal.close();
                },
                () => this.logger.error('Failed to archive employee'),
            ),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
